import React, { useEffect, useState } from "react";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { SolidButton } from "components/buttons/SolidButton";
import googleSvg from "../../assets/svg/google.svg";
import loadingSpinner from "../../assets/svg/spinner.svg";
import { useTranslation } from "react-i18next";
import { LoginWithGoogle } from "store/actions/authActions/LoginWithGoogle";
import { UserData } from "pages/SignUpPage";
import { useNavigate } from "react-router-dom";
interface Props {
  persistentLogin: boolean;
  signup: boolean;
  setRedirect: React.Dispatch<React.SetStateAction<boolean>>;
  setUserData?: React.Dispatch<React.SetStateAction<UserData | null>>;
  qrTokenToValidate?: string;
  setGoogleToken?: React.Dispatch<React.SetStateAction<string | null>>;
}

export const CapacitorGoogleAuthButton: React.FC<Props> = ({
  persistentLogin,
  signup,
  qrTokenToValidate,
  setGoogleToken,
  setRedirect,
}) => {
  const { t } = useTranslation();
  const language = t("localization_testing");
  const [initComplete, setInitComplete] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const REACT_APP_API_KEY = useAppSelector(
    (state) => state?.auth?.env?.REACT_APP_API_KEY
  );

  useEffect(() => {
    if (!initComplete && !!REACT_APP_API_KEY) {
      console.log("google init");
      GoogleAuth.initialize({
        clientId: REACT_APP_API_KEY,
        scopes: ["profile", "email"],
        grantOfflineAccess: true,
      });
      setInitComplete(true);
    }
  }, [REACT_APP_API_KEY, initComplete]);

  return (
    <div>
      <SolidButton
        onClick={async () => {
          setLoading(true);
          try {
            const googleResponse = await GoogleAuth.signIn();
            console.log(
              "this is googleResponse.authentication.idToken",
              googleResponse.authentication.idToken
            );
            if (!!setGoogleToken) {
              setLoading(false);
              return setGoogleToken(googleResponse?.authentication?.idToken);
            } else {
              setLoading(false);
              return dispatch(
                LoginWithGoogle(
                  language,
                  googleResponse.authentication?.idToken,
                  persistentLogin,
                  signup,
                  navigate,
                  setRedirect,
                  setLoading,
                  qrTokenToValidate
                )
              );
            }
          } catch (error) {
            console.log("there has been an error", error);
            setLoading(false);
          }
        }}
        blackText
        backgroundColor="bg-blue-100"
        hoverColor="bg-blue-200"
        width="w-full"
      >
        <div className="flex items-center cursor-pointer">
          {loading ? (
            <div>
              <img
                className="h-5 animate-spin"
                src={loadingSpinner}
                alt="loading"
              />
            </div>
          ) : (
            <div className="flex space-x-2">
              <span>{t("form.continueWith")}</span>
              <img className="h-5" src={googleSvg} alt="google" />
            </div>
          )}
        </div>
      </SolidButton>
    </div>
  );
};
